<template>
  <div class="content login">
    <div class="bg"></div>
    <div class="logo_img"></div>

    <div class="body">
      <a-spin
        tip="Loading..."
        :spinning="IsSubmit"
        wrapperClassName="spin_content"
      >
        <div name="login-form" class="login-form ng-pristine ng-valid">
          <div class="login_text">账号登录</div>
          <div class="login_txtbox1">
            <div class="imgdiv1"></div>
            <input
              class=""
              type="text"
              autocomplete="off"
              placeholder="账号"
              name="username"
              v-model="username"
              ref="username"
              @focus="clean"
              @keyup.enter="keyDown"
            />
          </div>
          <div class="login_txtbox2">
            <div class="imgdiv2"></div>
            <input
              class=" "
              type="password"
              autocomplete="off"
              placeholder="密码"
              name="password"
              v-model="password"
              ref="password"
              @focus="clean"
              @keyup.enter="keyDown"
            />
          </div>
          <div class="btn_login" @click="login">登&nbsp;&nbsp;&nbsp;录</div>
        </div>
        <div class="login_alert" v-show="login_alert" style="">
          <span style=""
            ><a class="close"></a
            ><span class="errorTxt">{{ errorTxt }}</span></span
          >
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      errorTxt: "",
      IsSubmit: false,
      ajax_count: 0,
      ajax_success_count: 0,
      ajax_err_count: 0,
      login_alert: false,
      login_rt: [],
      webtoken_list: [],
      err_list: [],
      params: {},
    };
  },
  methods: {
    login() {
      var that = this;
      if (that.IsSubmit) {
        return;
      }
      that.ajax_count = 0;
      that.ajax_success_count = 0;
      that.ajax_err_count = 0;
      if (!that.username || !that.password) {
        that.errorTxt = "请输入正确的用户名和密码！";
        that.login_alert = true;
        return;
      } else {
        that.params = {
          account: that.username,
          password: that.password,
        };
        that.login_alert = false;
        that.IsSubmit = true;
        for (var i = 0; i < that.webtoken_list.length; i++) {
          that.getajaxdata(i);
        }
      }
      return;
    },
    keyDown(e) {
      //如果是回车则执行登录方法

      console.log(e.keyCode, "监听按键");
      if (e.keyCode == 13) {
        if (!this.username) {
          this.$nextTick(() => {
            this.$refs.username.focus();
          });
          return;
        }
        if (!this.password) {
          this.$nextTick(() => {
            this.$refs.password.focus();
          });
          return;
        }
        this.login();
      }
    },
    getajaxdata(i) {
      var that = this;

      var version_model = manage.versions.find((n2) => {
        return n2.v == that.webtoken_list[i].version;
      });
      if (!version_model) {
        alert("平台" + that.webtoken_list[i].version + "没有配置");
        return;
      }
      var params = {};
      for (var item in version_model.loginParams) {
        params[item] = version_model.loginParams[item]
          .replace("${UserName}", that.params.account)
          .replace("${Password}", that.params.password);
      }
      console.log(version_model, "version_model");
      console.log(params, "params");
      that.public_function.h_Ajax(
        that.webtoken_list[i].url + that.webtoken_list[i].login,
        "post",
        params,
        {},
        2,
        function (data) {
          //判断token获取方式
          switch (that.webtoken_list[i].version) {
            case "v2": {
              if (data.data.token == null) {
                that.webtoken_list[i].token = "";
              } else {
                that.webtoken_list[i].token = data.data.token;
              }
              break;
            }
            default: {
              that.err_fun(i, data.message);
              break;
            }
          }

          that.ajax_count++;
          that.ajax_success_count++;
          console.log(that.ajax_count, "ajax_count");
          console.log(that.ajax_success_count, "ajax_success_count");

          if (that.ajax_count == that.webtoken_list.length) {
            that.successLogin();
          }
        },
        function (data) {
          that.err_fun(i, data);
        }
      );
    },
    err_fun(i, message) {
      var that = this;
      that.err_list.push(message);
      that.ajax_err_count++;
      that.ajax_count++;
      console.log(that.ajax_count, "ajax_count");
      console.log(that.ajax_err_count, "ajax_err_count");
      that.webtoken_list[i].token = "";
      if (that.ajax_count == that.webtoken_list.length) {
        that.successLogin();
      }
    },
    successLogin() {
      var that = this;
      that.IsSubmit = false;
      if (that.ajax_success_count > 0) {
        that.$store.commit("setToken", that.webtoken_list);
        console.log(JSON.parse(that.$store.getters.getToken));

        that.$router.push({ path: "/main" });
      } else {
        that.errorTxt = "登录失败";
      }
    },
    clean() {
      var that = this;
      that.login_alert = false;
    },
  },
  created() {
    var that = this;
    that.webtoken_list = [];

    let TOKEN = that.$store.getters.getToken;
    //有token

    if (TOKEN) {
      if (Is_Dev) {
        that.$confirm({
          title: "",
          content: "是否自动登录?",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            that.$router.push({ path: "/main" });
          },
          onCancel() {
            that.$store.commit("delToken");
          },
        });
      } else {
        //that.$router.push({ path: "/main" });
      }
    }
    //无token
    // that.$store.commit("delToken");
    //初始化 配置
    manage.system.forEach((n) => {
      var node = {};
      var version_model = manage.versions.find((n2) => {
        return n2.v == n.version;
      });
      node.id = n.id;
      node.url = n.url;
      node.version = n.version;
      node.login = version_model.login;
      node.menu = version_model.menu;
      node.token = "";
      that.webtoken_list.push(node);
    });
  },
};
</script>
<style lang="scss" scoped>
body {
  margin: 0;
  overflow: hidden;
}
.spin_content {
  width: 100%;
  height: 100%;
  position: relative;
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
}
.bg {
  position: absolute;
  left: 0;
  top: 0;
  // background-image: url("img/login/dlybg05.png");
  background-image: url("../../../../public/img/抚顺水务-统一登录页面-切图/bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  // height: 930px;
  // width: 1920px;
  width: 100vw;
  height: 100vh;
}
.logintbl {
  position: absolute;
  top: 400px;
  height: 90px;
  left: 913px;
  width: 260px;
}
.btn-success {
  position: absolute;
  top: 500px;
  left: 880px;
  width: 300px;
}

.login_alert {
  background-color: #ffc1c2;
  width: 100%;
  height: 26px;
  font-family: SimSun;
  font-size: 12px;
  color: #ff0000;
  text-align: center;
  line-height: 26px;
  position: absolute;
  top: 100%;
  left: 0;
}

.close {
  margin-top: 8px;
  margin-right: 8px;
  width: 9px;
  height: 9px;
  background-repeat: no-repeat !important;
  text-indent: -10000px;
  outline: none;
  background-image: url(img/login/remove-icon-small.png) !important;
}
/*登录页 样式开始*/
.login .body {
  float: left;
  width: 33vw;
  height: 330px;
  background-image: url(img/login/login.png);
  background-size: cover;
  position: fixed;
  top: calc(50% - 180px);
  left: 53%;
  padding: 30px;
}
.logo_img {
  background-image: url(img/login/logo.png);
  background-repeat: no-repeat;
  width: 25vw;
  height: calc(25vw * 124 / 359 );
  position: fixed;
  top: calc(50% - (25vw * 124 / 359)/2 - 3vh);
  left: 15%;
  background-size: 100%;
}
.login_img_text {
  border-left: 2px #838f99 solid;
  color: #838f99;
  top: calc(50% - 3.65vw);
  left: 22%;
  position: fixed;
  height: 6vw;
  padding-left: 1.8%;

  p:nth-child(1) {
    font-size: 1.8vw;
    font-weight: bold;
    line-height: 1.7vw;
    margin-top: 3.5%;
  }
  p:nth-child(2) {
    font-size: 1.2vw;
    line-height: 1.7vw;
  }
}
.login_text {
  font-size: 18px;
  color: #838f99;
  margin-bottom: 45px;
}
.login_txtbox1,
.login_txtbox2 {
  background: #d6ecff;
  display: flex;
  height: 56px;
  line-height: 56px;
  width: 65%;
  margin: 0 auto;
  border: 1px solid #d6ecff;
}
.body input {
  background: transparent;
  border: 0;
  padding: 0 10px;
  width: calc(100% - 60px);
  outline: none;
}
.imgdiv1 {
  background-image: url(img/login/dlyicon01.png);
}
.imgdiv2 {
  background-image: url(img/login/dlyicon02.png);
}
.login_txtbox1 .imgdiv1,
.login_txtbox2 .imgdiv2 {
  width: 56px;
  height: 56px;
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
}
.login_txtbox1.cur,
.login_txtbox2.cur {
  background: #fff;
  border: 1px solid #42befb;
}
.login_txtbox1 + .login_txtbox2 {
  border-top: 1px solid #ccc;
}
.login_txtbox1 + .login_txtbox2.cur {
  border-top: 1px solid #42befb;
}
.login_txtbox1 {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  /*border-bottom:1px solid #ccc;*/
}
.login_txtbox2 {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.btn_login {
  width: 65%;
  margin: 0 auto;
  margin-top: 30px;
  background: #37ce69;
  color: #fff;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-left: 17.5%;
  border: none;
  border-radius: 6px;
}
.btn_login {
  cursor: pointer;
}
</style>
